var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-block",style:({
    width: `${_vm.width}px`,
    height: `${_vm.height}px`,
    position: _vm.relative ? 'relative' : 'static',
    top: `${_vm.top}rem`,
    left: `${_vm.left}rem`
  })},[_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }